import {
    PageCollapsibleBlock,
    usePortalStore,
    EmptyResultsFiltersPlaceholder,
} from '@servicetitan/cp-ui';
import { observer } from 'mobx-react';
import { FC, Fragment, SyntheticEvent } from 'react';
import { AgreementStatus, DashboardServiceAgreementsData } from '../../../api/portal-dashboard.api';
import { ServiceAgreementCoveredLocationsDrawer } from './service-agreement-drawer/components/service-agreement-covered-locations-drawer';
import { ServiceAgreementsListItem } from './service-agreement-list-item';
import { ServiceAgreementMapUrls } from './service-agreement-url-map';

interface DashboardServiceAgreementProps {
    loading: boolean;
    filtered: boolean;
    serviceAgreements?: DashboardServiceAgreementsData[];
    resetFilters(): void;
}

export const DashboardServiceAgreements: FC<DashboardServiceAgreementProps> = observer(props => {
    const { filtered, loading, resetFilters, serviceAgreements } = props;
    const allServiceAgreementHref = ServiceAgreementMapUrls.list;
    const { event } = usePortalStore();

    const onViewAllServiceAgreementClick = (e: SyntheticEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        event('redirect', ['service-agreements']);
    };

    const filteredServiceAgreements = serviceAgreements
        ?.filter(s => s.status === AgreementStatus.Sent)
        ?.slice(0, 3);

    return (
        <Fragment>
            <PageCollapsibleBlock
                icon="service_agreements"
                title="Service Agreements"
                count={filteredServiceAgreements?.length ?? 0}
                allRecordsHref={allServiceAgreementHref}
                loading={loading}
                onAllRecordsClick={onViewAllServiceAgreementClick}
                className="m-b-4"
            >
                {!filteredServiceAgreements?.length && (
                    <EmptyResultsFiltersPlaceholder
                        title="No service agreements"
                        description="Service agreements will show up here"
                        className="m-y-3"
                        showFilterButtons={filtered}
                        onClearFiltersClick={resetFilters}
                    />
                )}
                {filteredServiceAgreements?.map(agreement => (
                    <ServiceAgreementsListItem key={agreement.id} serviceAgreement={agreement} />
                ))}
            </PageCollapsibleBlock>
            <ServiceAgreementCoveredLocationsDrawer />
        </Fragment>
    );
});
